<div class="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center tw:px-6 tw:py-16">
    @if (waitingForTeyaTerminal()) {
        <div class="tw:p-4">
            <app-loader />
        </div>

        <div class="tw:text-center">
            <div class="tw:text-sm tw:font-semibold">
                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.waitingPayment' | translate }}
            </div>
            <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">{{ unchargedTeyaAmount() / 100 | merchantCurrency }}</div>
        </div>

        <div class="tw:py-4">
            <app-button size="sm" type="secondary" [disabled]="cancellingTeyaPayment()" (clickEvent)="cancelTeyaTerminal()">{{
                'GENERAL.cancel' | translate
            }}</app-button>
        </div>
    } @else if (waitingForMbWay()) {
        <span
            class="tw:mb-2 tw:flex tw:h-12 tw:w-12 tw:items-center tw:justify-center tw:overflow-hidden tw:!rounded-full tw:bg-primary-50"
        >
            <img src="assets/mbway-mark.png" alt="MB Way" class="tw:h-8 tw:w-8 tw:object-contain" />
        </span>

        <div class="tw:text-center">
            <div class="tw:text-sm tw:font-semibold">
                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.mbwaySent' | translate }}
            </div>
            <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">
                {{ (pendingMbWayPayment()?.amountCents || 0) / 100 | merchantCurrency }}
                @if (pendingMbWayPayment()?.phone) {
                    · {{ pendingMbWayPayment()?.phone }}
                }
            </div>
            <div class="tw:mt-2 tw:text-xs tw:text-neutral-400">
                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.waitingMbWayApproval' | translate }}
            </div>
        </div>

        <div class="tw:mt-4">
            <app-loader></app-loader>
        </div>

        @if (mbWayCancelAllowed()) {
            <div class="tw:py-4">
                <app-button size="sm" type="secondary" (clickEvent)="cancelMbWayWaiting()">{{
                    'GENERAL.cancel' | translate
                }}</app-button>
            </div>
        }
    } @else if (livePaymentFailed()) {
        <div class="tw:mb-4 tw:flex tw:h-16 tw:w-16 tw:items-center tw:justify-center tw:rounded-full tw:bg-error-100">
            <i class="material-icons icon tw:!text-error-600 tw:!text-4xl">close</i>
        </div>

        <div class="tw:mb-6 tw:text-center">
            <h6 class="tw:h6 tw:mb-2">{{ 'INVOICE_SUCCESS.paymentFailedTitle' | translate }}</h6>
            <div class="tw:text-sm tw:text-neutral-500">
                {{ 'INVOICE_SUCCESS.paymentFailedDescription' | translate }}
            </div>
        </div>

        <div class="tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-2 tw:p-4">
            <app-button type="primary" size="md" extraClass="tw:w-64" (clickEvent)="goBackToEdit()">
                {{ 'INVOICE_SUCCESS.editAndRetry' | translate }}
            </app-button>

            @if (teyaPaymentFailed() && completeInvoiceData()?.id) {
                <app-button type="secondary" size="md" extraClass="tw:w-64" (clickEvent)="sendSaleToTeyaTerminal()">
                    {{ 'INVOICE_SUCCESS.retryTeyaTerminal' | translate }}
                </app-button>
            }
        </div>
    } @else {
        <div class="tw:mb-4 tw:flex tw:h-16 tw:w-16 tw:items-center tw:justify-center tw:rounded-full tw:bg-success-100">
            <i class="material-icons icon tw:!text-success-600 tw:!text-4xl">check</i>
        </div>

        <div class="tw:mb-6 tw:text-center">
            <h6 class="tw:h6 tw:mb-2">{{ 'INVOICE_SUCCESS.success' | translate }}</h6>
            @if (completeInvoiceData()?.invoiceReference) {
                <div class="tw:text-sm tw:font-medium tw:text-neutral-500">
                    {{ 'GENERAL.invoice' | translate }} {{ completeInvoiceData()?.invoiceReference || '-' }}
                </div>
            }
        </div>

        @if (completeInvoiceData()?.invoiceEmissionFailed) {
            <div class="tw:mb-4 tw:w-full tw:max-w-md">
                <app-alert type="warning"
                    [title]="'INVOICE_SUCCESS.invoiceFailedTitle' | translate"
                    [msg]="'INVOICE_SUCCESS.invoiceFailedDescription' | translate"
                 />
            </div>
        }

        <div class="tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-2 tw:p-4">
            <app-button type="primary" size="md" extraClass="tw:w-64" (clickEvent)="goToStart()">
                {{ 'INVOICE_SUCCESS.conclude' | translate }}
            </app-button>

            @if (completeInvoiceData()?.invoicePdfUrl) {
                <app-button type="secondary" size="md" extraClass="tw:w-64" (clickEvent)="emailInvoice(completeInvoiceData())">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">mail_outline</i>
                    {{ 'INVOICE_SUCCESS.emailInvoice' | translate }}
                </app-button>

                <app-button type="secondary" size="md" extraClass="tw:w-64" (clickEvent)="printInvoice(completeInvoiceData())">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">print</i>
                    {{ 'INVOICE_SUCCESS.printInvoice' | translate }}
                </app-button>

                <div class="invoice-success-more-options" dropdown placement="bottom">
                    <button dropdownToggle class="btn btn-md btn-secondary tw:w-64" type="button">
                        {{ 'INVOICE_SUCCESS.moreOptions' | translate }}
                        <i class="material-icons icon">arrow_drop_down</i>
                    </button>
                    <ul *dropdownMenu class="dropdown-menu">
                        @if (completeInvoiceData()?.invoiceTicketPdfUrl) {
                            <li>
                                <a class="dropdown-item" (click)="printTicket(completeInvoiceData())">
                                    <i class="material-icons icon">receipt</i>
                                    {{ 'INVOICE_SUCCESS.printTicket' | translate }}
                                </a>
                            </li>
                        }
                        <li>
                            <a class="dropdown-item" (click)="downloadInvoice(completeInvoiceData())">
                                <i class="material-icons icon">file_download</i>
                                {{ 'INVOICE_SUCCESS.downloadInvoice' | translate }}
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="openSaleDetails()">
                                <i class="material-icons icon">receipt_long</i>
                                {{ 'INVOICE_SUCCESS.openSaleDetails' | translate }}
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="goToSales()">
                                <i class="material-icons icon">shopping_cart</i>
                                {{ 'INVOICE_SUCCESS.goToSales' | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
            } @else {
                <app-button type="secondary" size="md" extraClass="tw:w-64" (clickEvent)="openSaleDetails()">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">receipt_long</i>
                    {{ 'INVOICE_SUCCESS.openSaleDetails' | translate }}
                </app-button>

                <app-button type="secondary" size="md" extraClass="tw:w-64" (clickEvent)="goToSales()">
                    <i class="material-icons icon tw:!text-primary-400 tw:mr-2">shopping_cart</i>
                    {{ 'INVOICE_SUCCESS.goToSales' | translate }}
                </app-button>
            }
        </div>
    }
</div>
